import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "text-sm px-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("option", { value: "" }, " Select ", -1)
const _hoisted_3 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("select", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localeKeys, (locale, index) => {
      return (_openBlock(), _createElementBlock("option", {
        key: index,
        value: locale
      }, _toDisplayString(locale), 9, _hoisted_3))
    }), 128))
  ]))
}